export default __webpack_public_path__ + "static/media/Privacy Dodewaards Mannenkoor.eef89fcb.pdf";